module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('b', [_vm._v("ACKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Special thanks to the following for their priceless contributions and assistance: Jack Nickels, the Rocky River Historical Society; Louise Varisco, the Strongsville Historical Village; George and Mary Krejci, Chad Thomas, John Nanovsky, Matthew Rump, Ryan McCarbery, Patricia Mahon, Rebecca E. Haaga, Amanda Francazio and Greg Palumbo, the Lakewood Historical Society; Paul Nelson, the Western Reserve Fire Museum and Education Center; Gayle Hill and Charles Cassady Jr., the Western Reserve Historical Society; Ware Petznick, the Shaker Historical Society; Marcia Anselmo, the Gates Mills Historical Society; Roy Larick and Dave Lawrence, the Euclid Historical Museum; the Cleveland Public Library; Cleveland State University; Janet Wood; Lucy Fiore; and Laura Hine.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738ac4a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ack.vue
// module id = 66
// module chunks = 0